// ThemeWrap.js
import {
  defineComponent,
  computed,
  inject,
} from "/Scripts/vue.esm-browser.js";
import CardWrap from "/Component/Shop/product/CardWrap.js";
import { getTextWithoutSign } from "/Scripts/tools.js";
const html = String.raw;
export default defineComponent({
  name: "ThemeWrap",
  components: {
    CardWrap,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isFilterOpen: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["groupShowType"],
  emits: [],
  setup(props, { emit }) {
    const isShowUni = computed(() => {
      return props.groupShowType === "uni";
    });
    const allProductPopup = inject("allProductPopup");
    const allProductBaseData = inject("allProductBaseData");
    const nowPage = inject("nowPage");

    //判斷是否沒產品(例如篩選條件太嚴苛)
    const hasProduct = (data) => {
      let hasGroups = false;
      data.forEach((item) => {
        if (item.groups.length > 0) {
          hasGroups = true;
        }
      });
      return hasGroups;
    };
    return {
      isShowUni,
      allProductPopup,
      allProductBaseData,
      nowPage,
      hasProduct,
    };
  },
  template: html`
    <div
      class="theme_wrap"
      :data-theme-name="getTextWithoutSign(item.otherAreaName)"
    >
      <div class="theme_title" v-if="item.otherAreaName">
        {{ item.otherAreaName }}
      </div>
      <!-- 依出發地為區塊  -->
      <div
        class="depart_wrap"
        v-for="departureGroup in item.departureGroups"
        :key="departureGroup.departureCode"
      >
        <div class="depart_title" :class="{'alldepart_date':isShowUni}">
          【{{departureGroup.departure}}出發】
          <span
            @click="openAllProductPopup(departureGroup,item.otherAreaName)"
            v-if="hasProduct(departureGroup.items)"
          >
            所有出發日期
            <i class="fa-solid fa-circle-chevron-right"></i>
          </span>
        </div>
        <!-- 放產品圖卡條列的地方 -->
        <card-wrap :items="departureGroup.items" :isFilterOpen="isFilterOpen" />
      </div>
    </div>
  `,
  methods: {
    getTextWithoutSign(text) {
      return getTextWithoutSign(text);
    },
    openAllProductPopup(data, otherAreaName) {
      this.allProductPopup = true;
      this.allProductBaseData = {
        data: data.items,
        subArea: data.subArea,
        otherAreaName: otherAreaName,
        departure: data.departure,
        type: "departure",
      };
      this.nowPage = 1;
    },
  },
});
